import ContactSellerModal from './contactSellerModal'

export default ContactSellerModal
